import { Link } from '@inertiajs/react'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { Button } from '@/components/ui/button'
import { useBasePath } from '@/lib/paths'
import { CheckCircle2, ArrowLeft } from 'lucide-react'

type Filing = {
  id: string
  type_name: string
}

type Record = {
  id: string
  period_start_date: string
  period_end_date: string
}

type Completion = {
  id: string
  created_at: string
} | null

type Props = {
  filing: Filing
  record: Record
  completion: Completion
}

export default function ComplianceFilingRecordsCompletionsShow({ filing, record, completion }: Props) {
  const basePath = useBasePath()

  return (
    <DashboardLayout
      title="Completion"
      breadcrumbs={[
        { label: 'Compliance Filings', href: 'compliance_filings' },
        { label: filing.type_name, href: `compliance_filings/${filing.id}` },
        { label: `${record.period_start_date} - ${record.period_end_date}`, href: `compliance_filings/${filing.id}/records/${record.id}` },
        { label: 'Completion' },
      ]}
    >
      <div>
        <div className="mb-8">
          <h1 className="text-xl font-semibold tracking-tight">Completion</h1>
          <p className="text-sm text-muted-foreground">{record.period_start_date} — {record.period_end_date}</p>
        </div>

        <div className="space-y-6">
          <section className="border rounded-lg">
            <div className="px-4 py-3 border-b">
              <h2 className="text-sm font-medium text-foreground">Filing Period Status</h2>
            </div>
            <div className="px-4 py-3">
              {completion ? (
                <div className="space-y-1.5">
                  <div className="flex items-center gap-2">
                    <CheckCircle2 className="w-4 h-4 text-green-600" />
                    <span className="text-sm font-medium text-green-600">Completed</span>
                  </div>
                  <div className="flex justify-between text-sm mt-2">
                    <span className="text-muted-foreground">Completed on</span>
                    <span>{new Date(completion.created_at).toLocaleDateString()}</span>
                  </div>
                </div>
              ) : (
                <p className="text-sm text-muted-foreground text-center py-4">Not yet completed</p>
              )}
            </div>
          </section>

          <div>
            <Button variant="outline" asChild>
              <Link href={`${basePath}/compliance_filings/${filing.id}/records/${record.id}`}>
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Record
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}
